import React from 'react';

const Bone = ({ w, h = 12, round = false }) => (
  <span className="ui-skel sd-bone" style={{ width: w, height: h, borderRadius: round ? '50%' : undefined }} />
);

/**
 * The student page while it loads: the hero, the four tiles and two course cards in their real
 * places, so the page does not jump when the data lands. It fades in after 150ms, so a fast answer
 * never flashes it.
 */
function StudentDetailSkeleton({ label }) {
  return (
    <div className="sd-skel" role="status" aria-busy="true" aria-label={label}>
      <div className="section-card sd-skel-hero" aria-hidden="true">
        <Bone w={64} h={64} round />
        <div className="sd-skel-lines">
          <Bone w="38%" h={14} />
          <Bone w="52%" h={12} />
        </div>
        <Bone w={132} h={40} />
      </div>
      <div className="kpi-row" aria-hidden="true">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="section-card sd-skel-tile">
            <Bone w="55%" h={12} />
            <Bone w="40%" h={28} />
            <Bone w="70%" h={11} />
          </div>
        ))}
      </div>
      <div className="sd-skel-cards" aria-hidden="true">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="section-card sd-skel-card">
            <Bone w="60%" h={18} />
            <Bone w="100%" h={8} />
            <Bone w="45%" h={12} />
            <Bone w="100%" h={72} />
          </div>
        ))}
      </div>
      <span className="visually-hidden">{label}</span>
    </div>
  );
}

export default StudentDetailSkeleton;
